import Navbar from "../../components/Navbar";
import { useEffect, useState } from "react";
import { LocationWrapper } from "../../components/LocationWrapper";
import { Modal, notification, Select, Button } from "antd";
import Footer from "../../components/Footer";
import { useLocation } from "react-router-dom";
import { _get_cities_by_state_code, _restaurants_in_lga } from "../../common/axios_services";
import ImageSlider from "../../components/sliders/ImageSlider";
import ValentineImg from "../../assets/images/restaurant/vALENTInes.png";
import Promo from "../../assets/images/restaurant/refer.png";
import BonusImg from "../../assets/images/restaurant/bonus.png";
import CheckoutImg from "../../assets/images/restaurant/checkout.png";
import { CloseCircleFilled } from '@ant-design/icons';
import RestaurantSlider from '../../components/sliders/RestaurantSlider';
import RestaurantCard from '../../components/Restaurant/RestaurantCard';


const Restaurant = () => {
  const [all_lgas, set_all_lgas] = useState([]);
  const [selectedLGA, setSelectedLGA] = useState("");
  const [tempSelectedLGA, setTempSelectedLGA] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [restaurants, setRestaurants] = useState([]);
  const location = useLocation();

  const promoImages = [Promo, BonusImg, CheckoutImg];

  const isMobileDevice = () => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      description: message,
    });
  };

  // Fetch LGAs for Lagos
  const fetchCities = async (state_code = "LA", keyword = "") => {
    try {
      const uploadedCities = await _get_cities_by_state_code(state_code, keyword);
      set_all_lgas(uploadedCities.data.data);
    } catch (err) {
      openNotificationWithIcon("error", err.message);
      set_all_lgas([]);
    }
  };

  // Fetch restaurants for selected LGA
  const fetchRestaurants = async (lga) => {
    try {
      const response = await _restaurants_in_lga({
        page: 1,
        per_page: 1000,
        state: "Lagos",
        lga: lga,
      });
      const lgaParts = lga.split("&").map((part) => part.trim().toLowerCase());
      let filteredRestaurants = response.data.data.filter((restaurant) => (
        restaurant.city &&
        lgaParts.some((lgaPart) => restaurant.city.toLowerCase().includes(lgaPart)) &&
        restaurant.status === "approved" &&
        restaurant.is_open === true
      ));
      setRestaurants(filteredRestaurants.length === 0 ? [] : filteredRestaurants);
      return filteredRestaurants;
    } catch (err) {
      openNotificationWithIcon("error", err.message);
      setRestaurants([]);
      return [];
    }
  };

  // Initialize data and check URL params
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const lgaFromQuery = params.get("lga");
    const initializeData = async () => {
      if (lgaFromQuery) {
        setSelectedLGA(lgaFromQuery);
        localStorage.setItem("selectedLGA", lgaFromQuery);
        const filteredRestaurants = await fetchRestaurants(lgaFromQuery);
        if (filteredRestaurants.length === 0) {
          openNotificationWithIcon('info', 'No restaurants available for this location.');
        }
      } else {
        setIsModalVisible(true);
        setRestaurants([]);
      }
      await fetchCities();
    };
    initializeData();
  }, [location.search]);

  // Reset temp selection when modal opens
  useEffect(() => {
    if (isModalVisible) {
      setTempSelectedLGA("");
    }
  }, [isModalVisible]);

  // Handler for LocationWrapper (immediate processing)
  const handleLGAChange = async (value) => {
    setSelectedLGA(value);
    localStorage.setItem("selectedLGA", value);
    await fetchRestaurants(value);
    setIsModalVisible(false);
  };

  // Handler for modal selection (temporary)
  const handleTempLGAChange = (value) => {
    setTempSelectedLGA(value);
  };

  // Confirm location in modal
  const handleAddLocation = async () => {
    if (!tempSelectedLGA) return;
    setSelectedLGA(tempSelectedLGA);
    localStorage.setItem("selectedLGA", tempSelectedLGA);
    await fetchRestaurants(tempSelectedLGA);
    setIsModalVisible(false);
  };

  return (
    <>
      <div style={{ backgroundColor: '#F2F2F2' }}>
        <Navbar noShadow={true} adjustNavSize={true} />
        <LocationWrapper
          selectLoc={true}
          selectedLGA={selectedLGA}
          handleLGAChange={handleLGAChange}
          lagosLga={all_lgas}
        />

        <div className="px-4 md:px-24 mt-8 md:mt-14 mb-8 md:mb-12">
          <div className="relative w-full overflow-hidden rounded-xl md:rounded-3xl shadow-lg h-[150px] md:h-[300px]">
            <img
              src={ValentineImg}
              alt="promo"
              className="w-full h-full object-cover object-center"
            />

            {/* Text Overlay with vertical adjustment */}
            <div className="absolute inset-0 flex items-center justify-center -translate-y-1">
              <div className="text-center text-white">
                <div className="text-3xl md:text-6xl font-bold">
                  RESTAURANTS
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* section 3 */}
        {/* <RestaurantCardDeals /> */}
        <div className="mt-2 md:mt-16 px-4 md:px-24 mb-12">
          {isMobileDevice() ? (
            // Slider for mobile
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-10">
              <div className="md:col-span-3">
                <ImageSlider images={promoImages} />
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-10">
              <img
                src={Promo}
                alt="promo"
                className="w-full object-cover rounded-xl shadow-lg"
                style={{ height: 'auto' }} // Let height adjust based on width
              />
              <img
                src={BonusImg}
                alt="bonus"
                className="w-full object-cover rounded-xl shadow-lg"
                style={{ height: 'auto' }}
              />
              <img
                src={CheckoutImg}
                alt="checkout"
                className="w-full object-cover rounded-xl shadow-lg"
                style={{ height: 'auto' }}
              />
            </div>
          )}
        </div>

        {/* Restaurant Listings */}
        <div className="mt-16 px-4 md:px-24 md:mb-10">
          <h4 className="text-4xl mb-4 md:mb-2 font-bold">Restaurants Near You</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-10">
            {restaurants.map((restaurant) => (
              <RestaurantCard key={restaurant.id} restaurant={restaurant} />
            ))}
          </div>
          {restaurants.length === 0 && (
            <p className="text-center text-gray-500 text-xl py-8">
              No restaurants found in this area
            </p>
          )}
        </div>

        <Modal
          open={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          footer={null}
          closable={false}
          maskClosable={false}
          centered
          className="custom-location-modal"
          bodyStyle={{ padding: '0' }}
        >
          <div className="bg-white p-8 rounded-lg">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl md:text-4xl font-bold text-gray-800">
                Select Your Location
              </h2>
              <CloseCircleFilled
                onClick={() => setIsModalVisible(false)}
                className="text-gray-500 hover:text-gray-700 cursor-pointer text-xl"
              />
            </div>
            <div className="space-y-4">
              <p className="text-gray-600 text-xl">
                Choose your local government area to see available restaurants
              </p>
              <Select
                value={tempSelectedLGA} // Use temporary state
                onChange={handleTempLGAChange}
                className="w-full location-select"
                placeholder="Search or select location..."
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {all_lgas.map((lga) => (
                  <Select.Option
                    key={lga.id}
                    value={lga.city_name}
                    className="location-option"
                  >
                    {lga.city_name}
                  </Select.Option>
                ))}
              </Select>
              {/* Add Location Button */}
              <Button
                type="primary"
                onClick={handleAddLocation}
                disabled={!tempSelectedLGA}
                className="w-full mt-4"
              >
                Add Location
              </Button>
            </div>
          </div>
        </Modal>
        <Footer />
      </div>
    </>
  )
}

export default Restaurant